import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/ActiveLicense',
    children: [
      {
        path: '/ActiveLicense',
        name: 'ActiveLicense',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/ActiveLicense/ActiveLicense.vue'),
      },
    ],
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/ZgyLicense',
    children: [
      {
        path: '/ZgyLicense',
        name: 'ZgyLicense',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/ZgyLicense/ActiveLicense.vue'),
      },
      {
        path: '/ZgyLicense/activeDetail',
        name: 'activeDetail',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/ZgyLicense/ActiveLicense.vue'),
      },
    ],
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/trainCert',
    children: [
      {
        path: '/trainCert',
        name: 'trainCert',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/TrainingCertificate/index.vue'),
      },
      {
        path: '/trainCert/login',
        name: 'trainCertLogin',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/TrainingCertificate/login.vue'),
      },
      {
        path: '/trainCert/detail',
        name: 'certUserDetail',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/TrainingCertificate/detail.vue'),
      },
    ],
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/AuthorizationLicense',
    children: [
      {
        path: '/AuthorizationLicense',
        name: 'AuthorizationLicense',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/AuthorizationLicense'),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
